export default __webpack_public_path__ + "static/media/fMaltoBuza14.00c6be2a.png";